/* eslint-disable max-len */
import React from 'react';
function PictureAsPdfOutlined() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H8V4h12v12z" }),
        React.createElement("path", { d: "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zM16 12V9c0-.55-.45-1-1-1h-2v5h2c.55 0 1-.45 1-1zm-2-3h1v3h-1V9zM18 11h1v-1h-1V9h1V8h-2v5h1z" }),
        React.createElement("path", { d: "M10 11h1c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1H9v5h1v-2zm0-2h1v1h-1V9z" })));
}
export default PictureAsPdfOutlined;
